import React, { useState, useEffect } from 'react';
import { KTIcon, toAbsoluteUrl } from '../../../helpers';
import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import clsx from 'clsx';
import DatePicker from 'react-datepicker';
import { get_all_coming_birthdays, get_all_coming_holidays } from '../api/widgetApi';
import { formatDatePickr } from '../../../../app/helper-functions/DateFunction';
import { Holiday, User } from '../../../../app/modules/accounts/components/settings/SettingsModel';
import { formatDateWithoutTime } from './../../../../app/helper-functions/DateFunction';

type Props = {
  className: string;
};

const ListsWidget4: React.FC<Props> = ({ className }) => {
  const [listingData, setListingData] = useState<any[]>([]);
  const currentStartDate = new Date();
  const currentYear = currentStartDate.getFullYear();
   // Calculate the last day of the current month
  const lastDayOfCurrentMonth = new Date(currentStartDate.getFullYear(), currentStartDate.getMonth() + 1, 0);
  const [startDate, setStartDate] = useState<string | null>(formatDatePickr(currentStartDate));
  const [endDate, setEndDate] = useState<string | null>(formatDatePickr(lastDayOfCurrentMonth));
  const { data: filterData, refetch: filterBirthday } = useQuery(
    'filterDataBirthdays',
    () => get_all_coming_birthdays(startDate, endDate),
    {
      onSuccess: (filteredData) => {
        setListingData(filteredData?.data);
      },
      onError: (error: any) => {
        if (error.response) {
        }
      },
      enabled: true, // Ensure this query only runs when explicitly triggered
      refetchOnWindowFocus:true,
    }
  );

  const handleApplyFilters = () => {
    filterBirthday(); // Trigger the query when applying filters
  };

  const handleClearFilters = () => {
    setStartDate(null);
    setEndDate(null);
    setListingData([]); // Clear the listing data
  };

  useEffect(() => {
    if (filterData && filterData.data) {
      setListingData(filterData.data);
    }
  }, [filterData]); // This effect will run when filterData changes

  return (
    <div className={clsx('card', className)}>
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold text-dark'>Upcoming Birthdays</span>
        </h3>
        <div className='card-toolbar'>
          <div className='d-flex'>
            <DatePicker
              selected={startDate ? new Date(startDate) : null}
              onChange={(date) => setStartDate(date ? formatDatePickr(date) : null)}
              placeholderText='From Date'
              dateFormat='dd-MM-yyyy'
              className='form-control'
              isClearable
              minDate={new Date()} // Prevent selection of past dates
            />
            <DatePicker
              selected={endDate ? new Date(endDate) : null}
              onChange={(date) => setEndDate(date ? formatDatePickr(date) : null)}
              placeholderText='To Date'
              className='form-control ms-2'
              dateFormat='dd-MM-yyyy'
              isClearable
              minDate={startDate ? new Date(startDate) : new Date()} // End date cannot be earlier than the start date
            />
            <button className='btn btn-primary ms-3' onClick={handleApplyFilters} title="Apply Filter">
              <i className="fa fa-filter"></i>
            </button>
            <button className='btn btn-secondary ms-2' onClick={handleClearFilters} title="Clear Filter">
            Clear
            </button>
          </div>
        </div>
      </div>
      <div className="card-body pt-5">
  {Array.isArray(listingData) && listingData.length > 0 ? ( // Ensure listingData is an array and not empty
    <div>
      {listingData.map((listData) => (
        <div key={listData?.id || Math.random()} className="d-flex align-items-sm-center mb-7">
          <div className="symbol symbol-50px me-5">
            <span className="symbol-label">
              <img
                src={
                  listData?.picture
                    ? listData.picture
                    : toAbsoluteUrl('/media/svg/general/user_default_profile.png')
                }
                className="h-50 align-self-center"
                alt={listData?.full_name || 'default-avatar'}
              />
            </span>
          </div>
          <div className="d-flex align-items-center flex-row-fluid flex-wrap">
            <div className="flex-grow-1 me-2">
              <a className="text-gray-800 text-hover-primary fs-6 fw-bold">
                {listData?.full_name || 'Unnamed User'}
              </a>
            </div>
            <div className="flex-grow-1 me-2">
              <span className="text-muted fs-7">
                <i className="fa fa-birthday-cake me-2 text-danger"></i>
                Celebrate with joy, love, and happiness!
              </span>
            </div>
            <div className="flex-grow-1 me-2">
              <span className="text-muted fs-7">
                {listData?.days_until_birthday
                  ? `${listData.days_until_birthday} Days Until Birthday`
                  : 'Date Unknown'}
              </span>
            </div>
            <span className="badge badge-light fw-bold my-2">
              {listData?.date_of_birth
                ? formatDateWithoutTime(listData.date_of_birth)
                : 'No Date'}
            </span>
          </div>
        </div>
      ))}
    </div>
  ) : (
    <div className="d-flex align-items-sm-center justify-content-center text-center">
      <div className="symbol symbol-150px me-5">
        <span className="symbol-label d-flex justify-content-center align-items-center">
          <img
            src={toAbsoluteUrl('/media/svg/general/gift-boxes.png')}
            className="h-50 align-self-center"
            alt="No Birthdays"
          />
        </span>
      </div>
      <span className="text-muted fw-bold fs-6 mt-2">No birthdays found.</span>
    </div>
  )}
</div>

    </div>
  );
};

export { ListsWidget4 };
